<template>
  <div class="adresa-wrapper nova-osoba-adresa">
    <div class="adresa-row-wrapper">
      <div class="adresa-element-wrapper">
        <label class="form-label" for="adresa">
          <span>{{ $t("forms.person.adresa.ulica_lbl") }}</span>
        </label><br>
        <input class="form-input" id="adresa" ref="adresa" />
      </div>
      <div class="adresa-element-wrapper">
        <label class="form-label" for="grad">
          <span>{{ $t("forms.person.adresa.grad_lbl") }}</span>
        </label><br>
        <input class="form-input" label="Grad" id="grad" ref="grad" />
      </div>
    </div>
    <br />
    <div class="adresa-row-wrapper">
      <div class="adresa-element-wrapper">
        <label class="form-label" for="post_br">
          <span>{{ $t("forms.person.adresa.post_br_lbl") }}</span>
        </label><br>
        <input
          class="form-input"
          label="Poštanski broj"
          id="post_br"
          ref="post_br"
        />
      </div>
      <div class="adresa-element-wrapper">
        <label class="form-label" for="drzava">
          <span>{{ $t("forms.person.adresa.drzava_lbl") }}</span><br>
        </label>
        <input 
          :class="['form-input']" 
          label="Država" 
          id="drzava" 
          ref="drzava" 
          @keyup.enter="addAddress()"
          title='Nakon unosa kliknite na Dodaj adresu za potvrdu unosa cijele adrese'
          />
      </div>
    </div>
    <div class="results-selected-wrapper" style="display: flex; opacity: 1;">
      <div v-for="(el, key) in lista_adresa" :key="key" class="result-selected">
        <div class="remove-result" @click="removeAddress(el)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
          >
            <g>
              <g>
                <path
                  fill="#eae9ee"
                  d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                />
              </g>
              <g>
                <path
                  fill="#191e2c"
                  d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                />
              </g>
            </g>
          </svg>
        </div>
        <div :class="'result-name rsn' + key">
          <span class="result-name-span"
            >{{ el.adresa }}, {{ el.post_br }}, {{ el.grad }}, {{ el.drzava }}
          </span>
        </div>
      </div>
    </div>
    <!-- *** Dodaj adresu**** -->
    <div class="button-create-wrapper" @click="addAddress()">
      <div class="button-default button-create">
        {{ $t("forms.person.adresa.add_addr") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
   props: ["base"],
  data() {
    return { lista_adresa: [] };
  },
  methods: {
    setData() {
      if(this.base.length > 0)
      {
        this.lista_adresa = this.base
      }
    },
    addAddress() {
      let adr = this.$refs.adresa.value;
      let gr = this.$refs.grad.value;
      let post = this.$refs.post_br.value;
      let drz = this.$refs.drzava.value;
      if (
        JSON.stringify({ adresa: adr, drzava: drz, grad: gr, post_br: post }) !=
        JSON.stringify({ adresa: "", drzava: "", grad: "", post_br: "" })
      ) {
        this.lista_adresa.push({
          adresa: adr,
          grad: gr,
          post_br: post,
          drzava: drz,
        });
      }
      this.$refs.adresa.value = "";
      this.$refs.grad.value = "";
      this.$refs.post_br.value = "";
      this.$refs.drzava.value = "";
    },
    removeAddress(el) {
      this.lista_adresa = this.lista_adresa.filter(
        (str) => JSON.stringify(str) != JSON.stringify(el)
      );
    },
  },
   mounted() {
    let vm = this;
    vm.$nextTick(function () {
      this.inputType = vm.id;
      setTimeout(this.setData, 1000);
      //   setTimeout(this.prijedlogBrojPredmeta, 1000);
    });
  },
};
</script>

<style></style>
